<template lang="html">
  <div class="gallery section" :data-index="index" @mouseenter="mouseActive = true" @mousemove="moveCursor" @mouseleave="mouseActive = false">
    <swiper :options="swiperOption" ref="swiper">
      <swiper-slide v-for="(slide, index) in project.content" :key="slide.id">
        <div v-if="slide.type === 'image'" class="inner" >
          <img :key="slide.image" :src="slide.image" />
        </div>
        <double v-if="slide.type === 'double'" :images="slide.double"></double>
        <div ref="text" :data-idx="index" v-else class="inner text" :class="slide.alignment">
          <div class="inner-text" v-html="slide.text">
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="pagination">
      {{ curIndex + 1 }} / {{ totalLength }}
    </div>
    <div class="project-title" @click="slideToText" v-html="title"></div>
    <div v-show="prev && mouseActive" class="prev" :style="{ top: y + 'px', left: x + 'px'}" @click="slideToPrev">Previous</div>
    <div v-show="next && mouseActive" class="next" :style="{ top: y + 'px', left: x + 'px'}" @click="slideToNext">Next</div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import {
  swiper,
  swiperSlide
} from 'vue-awesome-swiper'
import Double from '@/components/Double'

export default {
  props: {
    project: Object,
    index: Number,
  },
  components: {
    swiper,
    swiperSlide,
    Double
  },
  mounted() {
    window.addEventListener('click', this.click)
  },
  data() {
    return {
      x: 0,
      y: 0,
      next: false,
      prev: false,
      open: false,
      close: false,
      curIndex: 0,
      mouseActive: false,
      swiperOption: {
        preloadImages: false,
        speed: 700,
        loop: true,
        slidesPerView: 'auto',
        centeredSlides: true,
      }
    }
  },
  computed: {
    totalLength() {
      return this.project.content.length
    },
    title() {
      let title = this.project.title
      let split = title.split('')
      let newTitle = []
      for (var i = 0; i < split.length; i++) {
        var char = split[i]
        if (char == ' ') {
          char = '&nbsp;'
        }
        var string = '<span>' + char + '</span>'
        newTitle.push(string)
      }
      return newTitle.join('')
    },
    swiper() {
      return this.$refs.swiper.swiper
    },
  },
  methods: {
    click(event) {
      if (this.$route.name === 'projects') {
        let section = event.target.closest('.section')
        if (this.index == section.dataset.index) {
          if (event.clientX > (window.innerWidth / 2)) {
            this.slideToNext()
          } else {
            this.slideToPrev()
          }
        }
      }
    },
    slideToText() {
      let textSlide = this.$refs.text
      if (textSlide) {
        let num = textSlide[0].dataset.idx
        this.swiper.slideTo(num, 500)
        this.curIndex = this.swiper.realIndex
      }
    },
    slideToNext() {
      console.log('test')
      this.swiper.slideNext()
      this.curIndex = this.swiper.realIndex
    },
    slideToPrev() {
      this.swiper.slidePrev()
      this.curIndex = this.swiper.realIndex
    },
    moveCursor(event) {
      if (event.target.classList.contains('project-text') || event.target.classList.contains('inner-text') || event.target.classList.contains('close') || event.target.tagName == 'P') {
        this.next = false
        this.prev = false
        this.x = event.clientX
        this.y = event.clientY
        this.close = true
      } else if (event.target.classList.contains('project-title') || event.target.tagName == 'SPAN') {
        this.next = false
        this.prev = false
        this.close = false
      } else {
        let half = window.innerWidth / 2
        this.x = event.clientX
        this.y = event.clientY
        this.close = false
        if (this.x > half) {
          this.next = true
          this.prev = false
        } else {
          this.next = false
          this.prev = true
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.gallery {
    width: 100%;
    height: 100vh;
    scroll-snap-align: start;
    position: relative;
    cursor: none;
    // margin-bottom: 5em;
    @media only screen and (max-width: 768px) {
        cursor: auto;
    }
    &:last-of-type {
        margin-bottom: 0;
    }
    .project-text {}
}
.swiper-container,
.swiper-wrapper {
    height: 100%;
}
.swiper-slide,
.swiper-slide-duplicate {
    width: 70vw;
    box-sizing: border-box;
    margin: 0 4vw;
    @media only screen and (max-width:768px) and (orientation: portrait) {
        width: calc(100vw - 8vw);
    }
    @media only screen and (min-width:1200px) {
        width: calc(100vw - 32vw);
    }
    height: calc(100% - 0em);
    transform: translate3d(0,0,0) scale(0.9);
    transition: transform 0.5s;
    will-change: transform;
    &.swiper-slide-active,
    &.swiper-slide-duplicate-active {
        transform: translate3d(0,0,0) scale(1);
    }
    .inner {
        width: 100%;
        height: 100%;
        padding: 4vw 0;
        position: relative;
        &.left {
            text-align: left;
        }
        &.center {
            text-align: center;
        }
        &.right {
            text-align: right;
        }
        &.title {
            background: yellow;
            max-height: 100%;
            height: 52.5vw;
            position: absolute;
            width: 100%;
            box-sizing: border-box;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            h1 {
                position: absolute;
                width: calc(100% - .3em);
                box-sizing: border-box;
                top: 50%;
                text-align: center;
                transform: translateY(-50%);
                font-size: 5.8em;
                display: inline-block;
                @media only screen and (max-width:1380px) {
                    font-size: 3.1em;
                }
                @media only screen and (max-width:768px) {
                    font-size: 2em;
                }
            }
        }
        img {
            width: 100%;
            height: 100%;
            object-fit: contain;
            object-position: center center;
        }
        &.text {
            width: 100%;
            height: 100%;
            padding: 4vw 8vw;
            cursor: auto;
            @media only screen and (max-width:768px) {
                padding: 4vw;
            }
            .inner-text {
                overflow: auto;
                -webkit-overflow-scrolling: touch;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: center;
            }
        }
    }

}
.pagination {
    width: auto;
    position: absolute;
    bottom: 0;
    left: 0;
    padding: 0.5rem;
}
.project-title {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    padding: 0.5rem;
    z-index: 101;
    cursor: pointer;
    span {
        position: relative;
        display: inline-block;
        transition: transform 0.2s;
    }
    &:hover {
        span {
            &:nth-of-type(2) {
                transform: translate(0, -1rem);
            }
            &:nth-of-type(4) {
                transform: translate(0, -1.5rem);
            }
            &:nth-of-type(6) {
                transform: translate(0, -0.75rem);
            }
            &:nth-of-type(9) {
                transform: translate(0, -1rem);
            }
            &:nth-of-type(11) {
                transform: translate(0, -1.5rem);
            }
            &:nth-of-type(13) {
                transform: translate(0, -0.75rem);
            }
            &:nth-of-type(15) {
                transform: translate(0, -0.75rem);
            }
            &:nth-of-type(18) {
                transform: translate(0, -0.75rem);
            }
        }
    }
    @media only screen and (max-width: 768px) {
        left: auto;
        transform: none;
        right: 0;
    }

}
.close,
.next,
.prev {
    display: block;
    position: fixed;
    transform: translate(-50%,-50%);
    z-index: 99;
    outline: none;
    user-select: none;
    overflow: hidden;
    pointer-events: none;
    @media only screen and (max-width: 768px) {
        cursor: pointer;
        opacity: 0;
    }
}
.close {
    pointer-events: none;
}
</style>
